module.exports = __webpack_public_path__ + "static/scale-model-of-louisville-zoo-in-louisville-kentucky-f519beb7ad0f091b2e2cdb0c4d5d4f1f.png";